import * as React from 'react';
import './CollapsableItem.scss';
import { ListGroupItem, Collapse } from 'reactstrap';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ExpandLess from '@material-ui/icons/ExpandLess';
import Typography from '../Typography';

export interface CollapsableItemProps {
    id?: string,
    size?: 'sm'|'lg',
    title: React.ReactNode,
    style?: React.CSSProperties,
    className?: string,
    headerAlign?: 'left' | 'right',
    children: React.ReactElement,
    isOpen?: boolean,
    onSetOpen?: (isOpen: boolean) => void,
}
const CollapsableItem: React.FC<CollapsableItemProps> = (props) => {
    const {
        id,
        title,
        size = 'lg',
        children,
        style,
        className,
        headerAlign,
        isOpen: isOpenProp,
        onSetOpen: setOpenProp,
    } = props;

    const [isOpenState, setOpenState] = React.useState(false);

    const isControlled = isOpenProp === undefined && setOpenProp === undefined;

    const isOpen = isControlled ? isOpenState : isOpenProp;
    const setOpen = isControlled ? setOpenState : setOpenProp || (_ => {});

    return size === 'sm' ? 
    (
        <div className={className} style={style}>
            <div id={id ? `${id}-item-header` : undefined} className={`collapsableItemHeaderSmall${headerAlign === 'right' ? ' collapsableItemHeaderSmall--right' : ''}`} onClick={() => setOpen(!isOpen)}>
                <Typography size='smaller'>{title}</Typography>
                { isOpen ? (<ExpandLess />) : (<ExpandMore />)}
            </div>  
            <Collapse isOpen={isOpen}>
                {children}
            </Collapse>
        </div>
    )
    : (
        <ListGroupItem className={className} style={style}>
            <div id={id ? `${id}-item-header` : undefined} className="collapsableItemHeader" onClick={() => setOpen(!isOpen)}>
                <h5>{title}</h5>
                { isOpen ? (<ExpandLess />) : (<ExpandMore />)}
            </div>  
            <Collapse isOpen={isOpen}>
                {children}
            </Collapse>
        </ListGroupItem>
    );
}

export default CollapsableItem;